import pluginSource from './_plugin/picacg.js?raw';
import { loadSourceLoginSecret } from '@/db/sourceLoginSecrets';
import { createPicacgSource } from './source.ts';

const source = createPicacgSource({
  jsSource: `${pluginSource}\nnew Picacg();`,
  loadSavedLogin: () => loadSourceLoginSecret('picacg'),
});

export default source;
